import React, { useState, useRef, useEffect } from 'react'
import classNames from 'classnames';
import './index.scss';

interface IContentProps {
  contentText: string;
  className?: string;
}


export default function CollapseContent(props: IContentProps) {
  const { contentText, className } = props;
  const [showMore, setShowMore] = useState(false);
  const [textExpanded, setTextExpanded] = useState(false);
  const hiddenTextRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hiddenTextRef.current) return;
    const offsetWidth = hiddenTextRef.current.offsetWidth;
    console.log('hiddenTextRef offsetWidth issssssssss', hiddenTextRef.current.offsetWidth);
    if (offsetWidth > 190) {
      console.log('超长了~');
      setShowMore(true);
    }
  }, []);

  const onTapShowMore = () => {
    if (!showMore) return;
    setTextExpanded(preState => !preState);
  }

  return (
    <div
      // className="collapse-content" 
      className={classNames(`collapse-content ${className}`, {
        'content-expanded': textExpanded
      })}
      onClick={onTapShowMore}
    >
      <div
        className={classNames("content-text", {
          'expand-text': textExpanded
        })}
      >
        {contentText}
      </div>
      <div className="icon-side">
        {
          showMore && (
            <i
              className={classNames("arrow-down-icon", {
                'expanding': textExpanded
              })}
              // onClick={onTapShowMore}
            />
          )
        }
      </div>
      <div className="hidden-content" ref={hiddenTextRef} >
        {contentText}
      </div>
    </div>
  )
}